import { Sofa, Tv, Dumbbell, Flame, Tent, Warehouse, Blinds, LayoutPanelTop, DoorOpen } from "lucide-react";

export const SERVICES = [
  {
    id: "furniture", title: "Furniture Assembly", icon: Sofa, img: "/img/assembly.jpg",
    short: "Beds, dressers, desks, wardrobes, cribs — flat-pack to finished.",
    long: "From a single bookcase to a full room of flat-pack furniture, we build it square, tight and ready to use, following the manufacturer's instructions so it lasts.",
    items: ["Beds, bunk beds & cribs", "Dressers, wardrobes & armoires", "Desks & office chairs", "Dining tables & chairs", "Bookcases & entertainment units", "Patio & outdoor furniture"],
  },
  {
    id: "tv-mounting", title: "TV Mounting", icon: Tv, img: "/img/tv.jpg",
    short: "Level, secure wall mounts on the right studs and the right height.",
    long: "We locate studs, mount the bracket level and hang your TV at a comfortable viewing height. Bring the mount or ask us what works for your wall.",
    items: ["Fixed, tilting & full-motion mounts", "Stud locating & levelling", "Soundbars & media shelves", "Wall-mounted consoles"],
  },
  {
    id: "fitness", title: "Fitness Equipment", icon: Dumbbell, img: "/img/gym.jpg",
    short: "Treadmills, bikes, racks and home gyms built to spec.",
    long: "Heavy, awkward and full of parts — fitness gear is where assembly mistakes cost you. We build it to spec and check every bolt before we leave.",
    items: ["Treadmills & ellipticals", "Spin & stationary bikes", "Power racks & benches", "Multi-station home gyms", "Rowers & accessories"],
  },
  {
    id: "bbq", title: "BBQ Assembly", icon: Flame, img: "/img/bbq.jpg",
    short: "Gas, pellet and charcoal grills — ready for the first cookout.",
    long: "Grills come in a hundred pieces. We assemble gas, pellet and charcoal BBQs, plus smokers and outdoor kitchen carts, so you can get straight to cooking.",
    items: ["Gas & propane grills", "Pellet grills & smokers", "Charcoal & kamado grills", "Outdoor kitchen carts"],
  },
  {
    id: "gazebos", title: "Gazebos & Pergolas", icon: Tent, img: "/img/gazebo.jpg",
    short: "Hardtop and soft-top gazebos, pergolas and shade structures.",
    long: "Large outdoor kits need more than one set of hands. We assemble gazebos, pergolas and shade structures and anchor them as the kit allows.",
    items: ["Hardtop & soft-top gazebos", "Pergolas & shade sails", "Pop-up & permanent canopies", "Anchoring per manufacturer kit"],
  },
  {
    id: "sheds", title: "Sheds & Storage", icon: Warehouse, img: "/img/shed.jpg",
    short: "Resin, metal and wood shed kits assembled on your prepared base.",
    long: "Shed kits take patience and a plan. We assemble resin, metal and wooden sheds plus outdoor storage boxes on your prepared, level base.",
    items: ["Resin & vinyl sheds", "Metal sheds", "Wood shed kits", "Deck boxes & outdoor storage"],
  },
  {
    id: "blinds", title: "Blinds & Window Coverings", icon: Blinds, img: "/img/blinds.jpg",
    short: "Blinds, shades and curtain rods installed level and smooth.",
    long: "Measured, level and smooth-operating. We install blinds, shades, curtain rods and hardware throughout your home.",
    items: ["Horizontal & vertical blinds", "Roller & cellular shades", "Curtain rods & tracks", "Window hardware"],
  },
  {
    id: "shelving", title: "Shelving & Wall Storage", icon: LayoutPanelTop, img: "/img/shelving.jpg",
    short: "Floating shelves, closet systems, garage storage and more.",
    long: "Get things off the floor. We hang floating shelves, closet organizers, garage racks and wall storage — anchored for the load.",
    items: ["Floating & bracket shelves", "Closet organizer systems", "Garage shelving & racks", "Mirrors & wall art"],
  },
  {
    id: "gates", title: "Gates on Fences", icon: DoorOpen, img: "/img/gate.jpg",
    short: "Gate kits hung, aligned and latching properly.",
    long: "A gate that sags or won't latch is a daily annoyance. We install gate kits on existing fences, set hinges and latches, and make sure it swings true.",
    items: ["Wood & metal gate kits", "Hinges & latch hardware", "Gate alignment", "Self-closing hardware"],
  },
];

export const ALSO_ASSEMBLE = [
  "Kids' playsets", "Trampolines", "Basketball hoops", "Bikes", "Storage cabinets", "Baby gear",
  "Office cubicles", "Workbenches", "Pet enclosures", "Outdoor heaters", "Hot tub steps", "Mailboxes",
];
